import { XLg } from 'react-bootstrap-icons';

interface CartIconProps {
    closefunc: (viewable: boolean) => void;
}

function UICloseButton({closefunc}: CartIconProps){
    return (
        /* Need to write code to capture half stars */
        <> 
            <div className="d-inline-block">
                <XLg onClick={(e) => closefunc(false)} size={38} />
            </div>
        </>
    )
}

export default UICloseButton;